import React from 'react';
import { RichTextContentProps } from './RichTextContent';

const EmbeddedAssetBlock = ({ node }: RichTextContentProps) => {
  const fields = node?.data?.target?.fields;

  if (!fields) {
    return null;
  }

  const { title, file } = fields;

  return <>{file?.url && <img src={file.url} title={title} alt={title} />}</>;
};

export default EmbeddedAssetBlock;
